export const authRoutes = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/auth/LoginView.vue"),
    meta: { 
      layout: "auth",
      title: "Login"
    },
    children: []
  },

  {
    path: "/dashboard",
    name: "DashboardHome",
    component: () => import("@/views/dashboard/DashboardHome.vue"),
    meta: { 
      layout: "DashboardLayout",
      title: "Área do Parceiro"
    },
    children: [
      {
        path: "/boletos",
        name: "BoletosPagamentos",
        component: () => import("@/views/dashboard/financeiro/BoletosPagamentosView.vue"),
        meta: {
          layout: "DashboardLayout",
          title: "Boletos e Pagamentos"
        }
      }
    ]
  }
];
